import GridMui from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import { styles } from './styles';

const Grid = styled(GridMui)(styles);

export default Grid;
